/* global $ */
import React, { useEffect } from "react";

const Checkout2 = () => {
  useEffect(() => {
    // Ajout de jQuery
    const jqueryScript = document.createElement("script");
    jqueryScript.src = "https://ajax.googleapis.com/ajax/libs/jquery/2.2.4/jquery.min.js";
    jqueryScript.async = true;
    document.body.appendChild(jqueryScript);

    // Ajout de Leaflet (carte)
    const leafletCSS = document.createElement("link");
    leafletCSS.rel = "stylesheet";
    leafletCSS.href = "https://unpkg.com/leaflet/dist/leaflet.css";
    document.head.appendChild(leafletCSS);

    const leafletScript = document.createElement("script");
    leafletScript.src = "https://unpkg.com/leaflet/dist/leaflet.js";
    leafletScript.async = true;
    document.body.appendChild(leafletScript);

    // Ajout du widget jQuery Mondial Relay (ancienne version)
    const widgetScript = document.createElement("script");
    widgetScript.src = "https://widget.mondialrelay.com/parcelshop-picker/jquery.plugin.mondialrelay.parcelshoppicker.min.js";
    widgetScript.async = true;

    widgetScript.onload = () => {
      setTimeout(() => {
        if (window.$ && $("#Zone_Widget").MR_ParcelShopPicker) {
          $("#Zone_Widget").MR_ParcelShopPicker({
            Target: "#Target_Widget",
            Brand: "CC23GIF2", // Ton code ici (doit être 8 caractères, pad avec espaces)
            Country: "FR",
            PostCode: "75001",
            ColLivMod: "24R",
            NbResults: "7",
            Responsive: true,
            ShowResultsOnMap: true
          });
        }
      }, 500); // petit délai pour s'assurer que jQuery est chargé
    };

    document.body.appendChild(widgetScript);
  }, []);

  return (
    <div style={{ padding: "20px", textAlign: "center" }}>
      <h2>🛍️ Choisissez votre point relais</h2>
      <p>Vous pouvez sélectionner un point relais sur la carte ou via la recherche.</p>
      
      {/* Zone où s’intègre le widget */}
      <div id="Zone_Widget" style={{ margin: "20px auto", maxWidth: "100%" }}></div>

      {/* Zone cachée pour stocker l’ID sélectionné */}
      <input
        type="text"
        id="Target_Widget"
        style={{ display: "none" }}
        onChange={(e) => {
          console.log("Point sélectionné :", e.target.value);
          localStorage.setItem("selectedPointRelais", e.target.value);
        }}
      />

      <br />
      <a href="/checkout" className="btn" style={{ marginTop: "20px", display: "inline-block" }}>
        ✅ Continuer
      </a>
    </div>
  );
};

export default Checkout2;
